import { createFileRoute } from '@tanstack/react-router';

// The real OAuth callback is `/auth/github/callback`, handled server-side.
// `/login/callback` is a defensive client placeholder for the rare case that a
// stale link, manual URL entry, or bookmarked redirect lands the browser on
// this path. The user-spec includes this route as part of the SPA fallback
// contract — we render a quiet "Signing in…" message instead of a 404 so the
// owner is not greeted with a confusing blank page if they ever hit it.
export const Route = createFileRoute('/login/callback')({
  component: LoginCallback,
});

export function LoginCallback(): React.ReactElement {
  return (
    <div className="flex min-h-screen items-center justify-center px-6 text-sm text-ink-muted">
      <p>Signing in…</p>
    </div>
  );
}
